var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReportCaseAnalysisBeyond(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 71"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Polygon 10",
    d: "M5.07793 0.664595C5.27433 0.355334 5.72567 0.355334 5.92207 0.664596L9.77536 6.73195C9.98677 7.06483 9.74763 7.5 9.35328 7.5H1.64672C1.25238 7.5 1.01323 7.06483 1.22464 6.73195L5.07793 0.664595Z",
    fill: "#0EBC8B"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 26",
    x: 4,
    y: 7,
    width: 3,
    height: 5,
    rx: 0.5,
    fill: "#0EBC8B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportCaseAnalysisBeyond);
export default __webpack_public_path__ + "static/media/report_caseAnalysis_beyond.8df9cd8b742a2040d01026747e046796.svg";
export { ForwardRef as ReactComponent };